import React from 'react';

import { Grid, InputLabel } from '@material-ui/core';
import IconCircle from '@material-ui/icons/Brightness1';
import IconCheck from '@material-ui/icons/CheckCircle';

import LabelWithTooltip from '../LabelWithTooltip/LabelWithTooltip.component';
import { useStyles } from './LabelBlock.styles';

type LabelBlock = {
  label?: string;
  required?: boolean;
  tooltip?: string;
  iconTooltip?: React.ReactNode;
  error?: string;
  touched?: boolean;
  isErrorVisible?: boolean;
};

const LabelBlock: React.FC<LabelBlock> = (props) => {
  const {
    label,
    required = false,
    tooltip,
    iconTooltip,
    error,
    touched,
    isErrorVisible,
  } = props;

  const { invalidIconButton, labelBlock } = useStyles();

  return (
    <InputLabel className={labelBlock}>
      <Grid container justifyContent="space-between">
        <LabelWithTooltip
          label={label}
          required={required}
          tooltip={tooltip}
          icon={iconTooltip}
        />
        {error ? (
          touched &&
          !isErrorVisible && (
            <Grid item>
              <span className={invalidIconButton}>
                <IconCircle fontSize="small" />
              </span>
            </Grid>
          )
        ) : (
          <Grid item>
            <span className="label--icon-valid">
              <IconCheck fontSize="small" />
            </span>
          </Grid>
        )}
      </Grid>
    </InputLabel>
  );
};

export default LabelBlock;
